<template>
    <div>
        <div>
            <div class="mb-3" v-if="raidObject && requestObject">
                <span>{{ raidDescription }} по заявке <b-link :to="{ name: 'requestsDetail', params: { id: requestObject['id'] } }">№{{ requestObject['id'] }}</b-link></span>
            </div>
        </div>
        <b-form-row v-if="raid.id" class="">
            <gallery :label="'Фото'"
                     :root-api-url="galleryUrl"
                     :can-update="hasAbilityToUpdateAttachments"
                     :max-files="6"
                     :accepts="photoGalleryAccepts"
                     :upload-immediately="true"
                     :existing="Boolean(eventId)"
                     :max-size="25"
                     :kind="1"
                     ref="photoGallery"
                     class="col-xs-12 col-sm-12 col-md-6">
            </gallery>

            <gallery :label="'Видео'"
                     :root-api-url="galleryUrl"
                     :can-update="hasAbilityToUpdateAttachments"
                     :max-files="1"
                     :accepts="videoGalleryAccepts"
                     :upload-immediately="true"
                     :existing="Boolean(eventId)"
                     :max-size="30"
                     :kind="3"
                     ref="videoGallery"
                     class="col-xs-12 col-sm-12 col-md-6">
            </gallery>
        </b-form-row>

    </div>
</template>

<script>
import Gallery from "@/components/Files/Gallery";
import api from "@/api";
import {mapGetters} from "vuex";
import {Raid} from "@/pages/AppPages/Raids/raid";
import {Request} from "@/pages/AppPages/Requests/request";
import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import httpClient from "@/http";

export default {
    name: "HabitatAttributes",
    mixins: [ ObjectComponentMixin, AttributeMixin ],
    components: {Gallery},
    data() {
        return {
            raid: {},
            raidObject: {},
            request: {},
            requestObject: {}
        }
    },
    computed: {
        ...mapGetters(['ability', 'isSuperuser']),
        galleryUrl() {
            const raidUrl = api.raids.default.detail(this.raid.id)
            return `${api.raids.attachments.list(raidUrl)}`;
        },
        photoGalleryAccepts() { return ['image/jpeg', 'image/png', 'image/tiff'] },
        videoGalleryAccepts() { return ['video/mpeg', 'video/mp4'] },
        hasAbilityToUpdateAttachments() {
            // if (this.object && this.object.id) {
            //     return this.ability.can('update', this.object)
            // }
            return this.ability.can('update', 'DisposalEvent') && this.editable
        },
        raidDescription() { return this.raidObject && this.raidObject.id ? this.raidObject.objectLabel() : '—' }
    },
    beforeMount() {
        const vm = this;
        const raidId =  vm.eventData['release_raid_id'];
        const raidUrl = api.raids.default.detail(raidId);
        const requestId = vm.eventData['release_request_id'];
        const requestUrl = api.requests.default.detail(requestId)

        httpClient.get(raidUrl).then((response) => {
            vm.raid = response.data;
            vm.raidObject = new Raid();
            vm.raidObject.applyData(vm.raid);
            return httpClient.get(requestUrl)
        }).then((response) => {
            vm.request = response.data;
            vm.requestObject = new Request();
            vm.requestObject.applyData(vm.request)
        }).catch((reason) => {
            vm.$bvToast.toast(reason, { title: 'Ошибка при получении информации о выпуске с сервера', variant: 'danger'})
        })

        // this.raid = this.eventData['release_raid_object']
        // this.raidObject = new Raid();
        // this.raidObject.applyData(this.raid)
        //
        // this.request = this.eventData['release_request_object']
        // this.requestObject = new Request();
        // this.requestObject.applyData(this.request)
        //

    }
}
</script>

<style scoped>

</style>